interface IDestinationTypes {
  region: string;
  hotel: string;
  airport: string;
}

export const DestinationTypes: IDestinationTypes = {
  region: "region",
  hotel: "hotel",
  airport: "airport",
};
